/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { SinglePageView } from "components/document/page/SinglePageView";
import { getPagesViewYPos, getPagesViewXPos } from "selectors/pagedViewState";
import {
  getViewPortHeightWithoutPagesViewScrollbar,
  getViewPortWidthWithoutPagesViewScrollbar
} from "selectors/documentViewSelectors";
import { getPageHeight, getPageWidth } from "selectors/pageSelectors";
import { isFullScreenMode, isFitOneFullPageMode } from "selectors/documentSelectors";
import { getQuickToolsVisibility } from "selectors/documentSelectors";

const mapStoreToProps = (stores, ownProps) => ({
  pageIndex: ownProps.pageIndex,
  pagesViewXPos: getPagesViewXPos(stores),
  pagesViewYPos: getPagesViewYPos(stores),
  viewPortWidth: getViewPortWidthWithoutPagesViewScrollbar(stores),
  viewPortHeight: getViewPortHeightWithoutPagesViewScrollbar(stores),
  pageHeight: getPageHeight(stores, ownProps.pageIndex),
  pageWidth: getPageWidth(stores, ownProps.pageIndex),
  fitPageTopPosition: ownProps.fitPageTopPosition,
  fitPageViewHeight: ownProps.fitPageViewHeight,
  isFullScreenMode: isFullScreenMode(stores),
  isFitOneFullPageMode: isFitOneFullPageMode(stores),
  showQuickTools: getQuickToolsVisibility(stores)
});

const SinglePageContainer = inject(mapStoreToProps)(SinglePageView);

export { SinglePageContainer };
